import * as React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/global/layout';
import ModuleArea from '../components/ModularContent/ModuleArea';
import Circle from '../components/circle/circle';

const IndexPage = ({ data: { datoCmsHomepage } }) => {
  const { modularContent, heroImage, seoMetaTags } = datoCmsHomepage;
  return (
    <Layout hasSplash seo={seoMetaTags}>
      <Circle />
      {modularContent?.length > 0 && <ModuleArea blocks={modularContent} />}
    </Layout>
  );
};

export default IndexPage;

export const query = graphql`
  query {
    datoCmsHomepage {
      id: originalId
      title
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      modularContent {
        ... on DatoCmsHeroBlock {
          ...HeroBlock
        }
        ... on DatoCmsBrandsBlock {
          ...BrandsBlock
        }
        ... on DatoCmsAccordionBlock {
          ...AccordionBlock
        }
        ... on DatoCmsWorkSwiperBlock {
          ...WorkSwiperBlock
        }
        ... on DatoCmsTestimonialsBlock {
          ...TestimonialsBlock
        }
        ... on DatoCmsFormBlock {
          ...FormBlock
        }
        # ... on DatoCmsContactBlock {
        #   ...ContactBlock
        # }
      }
    }
  }
`;
